export default "__VITE_ASSET__c91214a1__"